module.exports = __webpack_public_path__ + "c808942acfe7e59d9282795c585f03b3.pdf";